import Vue from 'vue'
import Router from 'vue-router'
// //解决重复点菜单报红问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    { path: '/',
      redirect:'/index',
      component:()=> import('@/index'),
      children:[
        { path:'index', component:()=> import('@/components/home')},
        { 
          path: 'technology', 
          component:()=> import('@components/p4/technologyContainer'),
          children: [
            { path: '/', component:()=> import('@components/tec_page/technology_index') },
          ]
        },
        { 
          path: 'product', 
          component:()=> import('@components/p4/productContainer'),
          children:[
            { 
              path: 'industrial', 
              component:()=> import('@components/product_page/product_industrial'),
              children: [
                { path: '/', component:()=> import('@components/product_page/industrial_application_box/industrial_application_box1') },
                { path: 'application2', component:()=> import('@components/product_page/industrial_application_box/industrial_application_box2') },
                { path: 'application3', component:()=> import('@components/product_page/industrial_application_box/industrial_application_box3') },
                { path: 'application4', component:()=> import('@components/product_page/industrial_application_box/industrial_application_box4') },
                { path: 'application5', component:()=> import('@components/product_page/industrial_application_box/industrial_application_box5') },
              ]
            },
            { path: 'speech', component:()=> import('@components/product_page/product_index') },
            { 
              path: 'voice', 
              component:()=> import('@components/product_page/product_voice'),
              children: [
                { path: 'page1', component:()=> import('@components/product_page/voice_page/page1') },
                { path: 'page2', component:()=> import('@components/product_page/voice_page/page2') },
                { path: 'page3', component:()=> import('@components/product_page/voice_page/page3') },
                { path: 'page4', component:()=> import('@components/product_page/voice_page/page4') },
              ]
            }
          ]
        },
        { path: '/case', component:()=> import('@components/p4/caseContainer')},
        { 
          path: '/us', 
          component:()=> import('@components/p4/usContainer'),
          children: [
            { path: '/', component:()=> import('@components/us_page/introduction') },
            { 
              path: 'news', 
              redirect:'/us/news/page1',
              component:()=> import('@components/us_page/news/news_index'),
              children: [
                { path: 'page1', component:()=> import('@components/us_page/news/news_page1')},
                { path: 'page2', component:()=> import('@components/us_page/news/news_page2')},
                
          
              ]
              
            },
            { path: 'introduction', component:()=> import('@components/us_page/introduction') },
            { path: 'honor', component:()=> import('@components/us_page/honor') },
            { path: 'team', component:()=> import('@components/us_page/team')},
            { path: 'join_us', component:()=> import('@components/us_page/join_us')},
            { path: 'news20190328', component:()=> import('@components/us_page/news/news20190328')},
            { path: 'news20190806', component:()=> import('@components/us_page/news/news20190806')},
            { path: 'news20190902', component:()=> import('@components/us_page/news/news20190902')},
            { path: 'news20200301', component:()=> import('@components/us_page/news/news20200301')},
            { path: 'news20200401', component:()=> import('@components/us_page/news/news20200401')},
            { path: 'news20200408', component:()=> import('@components/us_page/news/news20200408')},
            { path: 'news20200416', component:()=> import('@components/us_page/news/news20200416')},
            { path: 'news20200519', component:()=> import('@components/us_page/news/news20200519')},
          ]
         },
        { path: '/us/join_us/android', component:()=> import('@components/us_page/join_us_post/android') },
      ]
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js